import Vue from 'vue';
import Router from 'vue-router';

import listing from './listing';
import singleProduct from './singleProduct';
import addFromCatalog from './addFromCatalog';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/products/all',
    },
    {
      path: '/products',
      redirect: '/products/all',
    },
    {
      path: '/products/products/all',
      redirect: '/products/all',
    },
    {
      path: '/products/products/single-product',
      redirect: '/products/single-product',
    },
    {
      path: '/products/products/add-from-catalog',
      redirect: '/products/add-from-catalog',
    },
    // başladı
    // TODO: gilgamesh change url
    {
      path: '/products/products/add-from-catalog/search',
      redirect: '/products/add-from-catalog',
    },
    {
      path: '/products/add-from-catalog/search',
      redirect: '/products/add-from-catalog',
    },
    // TODO: gilgamesh change url
    // bitti
    {
      path: '/products/products/action-needed',
      redirect: '/products/action-needed',
    },
    {
      path: '/products/products/rejected',
      redirect: '/products/rejected',
    },
    {
      path: '/products/products/out-of-stock',
      redirect: '/products/out-of-stock',
    },
    {
      path: '/products',
      component: {
        render (c) {
          return c('router-view');
        },
      },
      children: [
        addFromCatalog,
        singleProduct,
        listing,
      ],
    }],
  linkActiveClass: 'active',
  linkExactActiveClass: 'active-exact',
});

export default router;
